export default "__VITE_ASSET__DGWAY9Jn__"